import { SelectSymbolPriceLabel12 } from 'components/form/compobox/select-symbolpricelabel12'
export default function Symbol({brrand,index}) {
  return (
    <div className="space-y-2 border border-dashed p-2 rounded">
      <SelectSymbolPriceLabel12 washType="wash" brrand={brrand} index={index} />
      <SelectSymbolPriceLabel12 washType="bleach" brrand={brrand} index={index} />
      <SelectSymbolPriceLabel12 washType="tumble" brrand={brrand} index={index} />
      <SelectSymbolPriceLabel12 washType="iron" brrand={brrand} index={index} />
      <SelectSymbolPriceLabel12 washType="dry" brrand={brrand} index={index} />
    </div>
  )
}
  